import { Splide } from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function() {
    const sliders = document.querySelectorAll(".splide-section-split-richtext");

    // check if sliders are already initialized or not
    if (sliders.length === 0) {
        return;
    }

    // initialize every slider
    sliders.forEach(function(slider) {
        // check if slider has class .is-initialized
        if (slider.classList.contains("is-initialized")) {
            return;
        }

        const currentSlider = new Splide(slider, {
            type: "slide",
            rewind: true,
            pagination: false,
            perPage: 1,
            perMove: 1
        });

        currentSlider.mount();
    });
});
